import React, { useState, useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { withRouterProps } from '../utils/with-router-props'
import { routes, apiResourceEndpoint } from '../../constants/routes'
import { fetchApiDataIfNeeded } from '../../actions/api'
import { isEmpty } from 'lodash'

const mapStateToProps = (state) => {
    return {
        account: state.account,
        auth: state.auth,
        role: state.role,
        user: state.user
    }
}

const AuthRouter = ({ dispatch, user, location }) => {
    // const [readyToRoute, setReadyToRoute] = useState(false)
    const [onboardStatus, setOnboardStatus] = useState(null)
    const readyToRoute = useMemo(() => {
        if (user && 'id' in user) {
            if (user.id === -1) {
                setOnboardStatus('CREATE_USER')
                return false
            }
            return true
        }
        return false
    }, [user])

    // if (user && 'id' in user) {
    //     if (user.id === -1) {
    //         setOnboardStatus('CREATE_USER')
    //     } else {
    //         setReadyToRoute(true)
    //     }
    // }

    useEffect(() => {
        if (isEmpty(user)) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('users/load-details', 'LIST')))
        }
        // if (user && '_computed' in user) {
        //     setReadyToRoute(true)
        // }
    }, [dispatch, user])


    if (readyToRoute) {
        if (location.state && location.state.from.pathname) {
            return <Navigate to={location.state.from.pathname} />
        } else if (user._computed.roleLevel === 1000) {
            return <Navigate to={routes.adminIndex} />
        }
        return <Navigate to={routes.appIndex} />
        // const accountTypeName = user._computed.accountTypeName
        // // TODO: Check account type for where to send them, will have more later
        // if (accountTypeName === 'Luna Admin') {
        //     if (location.state && location.state.from.pathname) {
        //         return <Navigate to={location.state.from.pathname} />
        //     }
        //     return <Navigate to={routes.adminIndex} />
        // }
        // return <Navigate to={routes.appIndex} />
    }
    if (onboardStatus === 'CREATE_USER') {
        return <Navigate to={routes.authCreateUser} />
    }
    return <div>Loading routing information...</div>
}

export default withRouterProps(connect(mapStateToProps)(AuthRouter))
